// This file is automatically generated. Do not edit manually.

import { ObjectAttributeValueWithField } from "src/api/generated/erp/common/objectAttributes/model/objectAttributeValueWithField";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerOrderAttributesApi {
	export async function getCustomerOrderAttributes(args: {
		customerOrderId: number;
	}): Promise<Array<ObjectAttributeValueWithField>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/attributes/getCustomerOrderAttributes",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
			},
		});
		return response as Array<ObjectAttributeValueWithField>;
	}

	export async function saveCustomerOrderAttributes(args: {
		customerOrderId: number;
		attributes: Array<ObjectAttributeValueWithField>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/attributes/saveCustomerOrderAttributes",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
				attributes: args.attributes,
			},
		});
		return response as void;
	}
}
